import { type ICurrencyRepository } from '@webapp/core/business-logic/interfaces/ICurrencyRepository'
import { type CurrencyConstructor } from '@webapp/core/entities/external/Currency'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { mapCurrency } from '../../mappers/mapCurrency'
import { type GetCurrenciesResponse } from '../../types/GetCurrenciesResponse'

interface Dependency {
  httpClient: IHttpClient
}

export class CurrencyRepository implements ICurrencyRepository {
  constructor(private readonly deps: Dependency) {}

  async getAllActive(): Promise<CurrencyConstructor[]> {
    const res = await this.deps.httpClient.get<GetCurrenciesResponse>(
      '/api/v2/currencies/',
      {
        params: {
          active: true,
          page_size: 'all',
        },
      }
    )

    const currenciesData = res.data.data

    return currenciesData.map((currency) => mapCurrency(currency))
  }
}
